import React from 'react';
import {
  Container,
  Header,
  Segment,
  Grid,
  Button,
  Icon,
  Loader,
  Dimmer,
  Image
} from 'semantic-ui-react';

import { Link } from "react-router-dom";

import {withRouter, Redirect} from 'react-router';
import { compose } from 'redux';

import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
//<FormattedMessage id="audory.homepage.header.question" values={{name: 'Max Rose'}}/>

import InteractiveExample from './InteractiveExample/InteractiveExample';
import DivWrapper from './DivWrapper';
import EXISTComponent from './EXISTComponent';
import Logo from './Logo';
import Api from '../api/Api';
import AudoryPage from './PageComponents/AudoryPage';

import applePic from '../img/apple-badge.png';
import googlePlayPic from '../img/google-play-badge.png';
import appPreview from '../img/app_preview.png';

class HomePage extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      page: null,
      loading: true,
      hideIntro: true
    }
    
  }

  async componentDidMount(){
    window.scrollTo(0, 0);
    const pageId = this.props.match.params.id ? this.props.match.params.id : null;
    if(!this._isUnmounted) this.setState({hideIntro: pageId ? true : false, loading: true});
    
    let page = await Api.Page.getPage(pageId ? pageId : "").then(data => data.data.list).catch(err => null);
    //console.log(page);

    if(page && page.length !== 0){
      for(let i=0; i<page.listObjs.length; i++){
        switch(page.listObjs[i].type){
          case "single":
            page.listObjs[i].storyObj = await loadContentFromIds(page.listObjs[i].storyObj);
            break;
          case "list1":
          case "list2":
          case "list3":
            let ary = [];
            for(let k=0; k<page.listObjs[i].storiesObj.length; k++){
              ary.push(await loadContentFromIds(page.listObjs[i].storiesObj[k]));
            }
            page.listObjs[i].storiesObj = ary;
            break;
          case "card":
            if(page.listObjs[i].storyObj){
              page.listObjs[i].storyObj = await loadContentFromIds(page.listObjs[i].storyObj);
            }
            break;

        }
      }
    }
    if(!this._isUnmounted)this.setState({loading: false, page: page});
  }

  componentWillUnmount(){
    this._isUnmounted = true;
  }

  render() {
    return (
      <DivWrapper>
        <div style={{ border: 'none', padding: '0em', paddingTop: '1em', margin: 0, marginBottom: '2px' }}>
          {
            !this.state.hideIntro && (
              <Container text style={{marginTop: "3em"}}>
                
                <Logo />
                
                <Header as='h3' style={{ fontSize: '2em', marginTop: '1em' }}>
                  <center><FormattedMessage id="audory.homepage.header.head" /></center>
                </Header>
                {/*
                <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
                  <FormattedMessage id="audory.homepage.header.body" />
                </p>
                */}
              </Container>
            )
          }
          
          {
            !this.state.hideIntro && <InteractiveExample intl={this.props.intl} />
          }
          
          
          {
            this.state.loading ? (
              <div style={{display: 'table', height: "200px", width: "100%"}}>
                <div style={{display: "table-cell", textAlign: "center", verticalAlign: "middle"}}>
                  <Icon loading name='spinner' size="huge" color="black" />
                </div>
              </div>
            ) : (
              this.state.page && 
                <AudoryPage
                  page={this.state.page}
                  />
            )
          }

          {
            !this.state.hideIntro && (
              <Container textAlign='center' style={{marginTop: "4em", marginBottom: "4em"}}>
                <Header as='h1' icon>
                    <Icon name='search' />
                        <FormattedMessage id="audory.apppage.body.cta"/>
                    <Header.Subheader>
                        <FormattedMessage id="audory.apppage.body.cta.body"/>
                    </Header.Subheader>
                </Header>
                <Segment basic>
                    <Grid columns={2} centered>
                        <Grid.Column style={{textAlign: 'center'}}>
                            <Image as='a' href='https://apps.apple.com/app/id1538122365' src={applePic} style={{width: '15em'}} />
                        </Grid.Column>
                        <Grid.Column style={{textAlign: 'center'}}>
                            <Image as='a' href='https://play.google.com/store/apps/details?id=com.audoryapp' src={googlePlayPic} style={{ width: '15em'}} />
                        </Grid.Column>
                    </Grid>
                </Segment>
            </Container>
            )
          }



        </div>
      </DivWrapper>
    );
  }

}

export const loadContentFromIds = async (project) => {
  const cat = project.categoryObj;//await Api.Categories.getCategoryById(project.category).then(data => data.data).catch(err => 'Abenteuer');
  project.category = cat;

  if(typeof(project.authorId) !== 'string'){
    project.authorName = project.authors;
    /*
    for(let k = 0; k < project.authorId.length; k++) project.authorName.push(
        await Api.User.getName(project.authorId[k]).then(data => data.data).catch(err => null)
    );
    */
    project.authorName = {firstName: project.authorName.map(a => a.firstName + ' ' + a.lastName).join(" & "), lastName: ''};
  } else {
    project.authorName = "";//await Api.User.getName(project.authorId).then(data => data.data).catch(err => null);
  }

  if(typeof(project.speakerId) !== 'string'){
    project.speakerName = project.speakers;
    /*
    for(let k = 0; k < project.speakerId.length; k++) project.speakerName.push(
        await Api.User.getName(project.speakerId[k]).then(data => data.data).catch(err => null)
    );
    */
    project.speakerName = {firstName: project.speakerName.map(a => a.firstName + ' ' + a.lastName).join(" & "), lastName: ''};
  } else {
    project.speakerName = "";//await Api.User.getName(project.speakerId).then(data => data.data).catch(err => null);
  }

  project.cover = "https://covers-audory.s3.eu-central-1.amazonaws.com/"+project.cover; //await Api.Cover.getCoverFile(project.cover).then(data => data.data.signed).catch(err => null);
  //project.ownerName = await Api.User.getName(project.ownerId).then(data => data.data).catch(err => null);

  return project;
};
  
  
      
          /*
      <Container text style={{marginTop: '2em'}}>
        
<Header as='h3' style={{ fontSize: '2em' }}>
          <FormattedMessage id="audory.responsiveContainer.body.funding.headText" />
        </Header>
        <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
          <FormattedMessage id="audory.temp.29" />
        </p>
        <Grid columns={2} style={{textAlign: 'center', marginBottom: '2em'}}>
          <Grid.Row>
            <Grid.Column style={{width: '100%'}}>
                <Button
                color='green'
                size='big'
                icon
                labelPosition='right'
                href='/funding'
                >
                  <FormattedMessage id="audory.temp.27" />
                  <Icon name='right arrow' />
                </Button>
              </Grid.Column>
          </Grid.Row>
        </Grid>
        
        <Header as='h3' style={{ fontSize: '2em' }}>
          <FormattedMessage id="audory.temp.11" />
        </Header>
        <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
        <FormattedMessage id="audory.temp.16" /> <b><FormattedMessage id="audory.temp.17" /></b> <FormattedMessage id="audory.temp.18" /> <b><FormattedMessage id="audory.temp.19" /></b> <FormattedMessage id="audory.temp.20" /> 
        </p>
        <Grid columns={2} style={{textAlign: 'center'}}>
          <Grid.Row>
            <Grid.Column style={{width: '100%'}}>
                <Button
                color='green'
                size='big'
                icon
                labelPosition='right'
                href='/gutschein'
                >
                  <FormattedMessage id="audory.temp.21" />
                  <Icon name='right arrow' />
                </Button>
              </Grid.Column>
          </Grid.Row>
        </Grid>
        
      </Container>
<Container text style={{marginTop: '4em'}}>
        <Header as='h3' style={{ fontSize: '2em' }}>
          <FormattedMessage id="audory.homepage.community.head" />
        </Header>
        <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
          <FormattedMessage id="audory.homepage.community.body" />
        </p>
        <Grid columns={2} style={{textAlign: 'center'}}>
          <Grid.Row>
            <Grid.Column style={{width: '50%'}}>
              <Button
              color='green'
              icon
              labelPosition='left'
              href='https://www.facebook.com/groups/audory.autoren/'
              target='_blank'
              >
                <Icon name='facebook' />
                <FormattedMessage id="audory.homepage.community.authors" />
              </Button>
            </Grid.Column>
            <Grid.Column style={{width: '50%'}}>
              <Button
              color='green'
              icon
              labelPosition='left'
              href='https://www.facebook.com/groups/audory.hoere/'
              target='_blank'
              >
                <Icon name='facebook' />
                  <FormattedMessage id="audory.homepage.community.listeners" />
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>

      <Segment
          inverted
          vertical
          textAlign='center'
          style={{ padding: '3em 0em', marginTop: '4em' }}
          >
            <Container style={{width: '100%'}}>
              <Header as='h3' style={{ fontSize: '2em', color: 'white' }}>
                <FormattedMessage id="audory.homepage.decide.iam" />
              </Header>
              <Grid divided inverted stackable align='middle'>
                <Grid.Row>
                  <Grid.Column style={{width: '50%'}}>
                    <Grid.Row verticalAlign='middle' style={{height: '50%', display: 'table', padding: '2em'}}>
                      <Header as='h2' style={{ fontSize: '4em', color: 'white' }}>
                        <FormattedMessage id="audory.homepage.decide.author" />
                      </Header>
                    </Grid.Row>
                    <Grid.Row style={{height: '50%', display: 'table'}}>
                      <Header as='h4' style={{ fontSize: '1.3em', color: 'white' }}>
                        <FormattedMessage id="audory.homepage.decide.authorText" />
                      </Header>
                      <Button
                        as={Link}
                        to='/editor'
                        size='big'
                        onClick={()=>{window.scrollTo(0,0)}}
                        style={{marginTop: '1em', width: '15em'}}
                        color='green'>
                        <FormattedMessage id="audory.homepage.decide.authorButton" />
                      </Button>
                    </Grid.Row>
                  </Grid.Column>
                  <Grid.Column style={{width: '50%', paddingTop: 0}}>
                    <Grid.Row style={{height: '50%', display: 'table', padding: '2em'}}>
                    <Header as='h2' style={{ fontSize: '4em', color: 'white' }}>
                        <FormattedMessage id="audory.homepage.decide.user" />
                      </Header>
                    </Grid.Row>
                    <Grid.Row style={{height: '50%', display: 'table'}}>
                      <Header as='h4' style={{ fontSize: '1.3em', color: 'white' }}>
                        <FormattedMessage id="audory.homepage.decide.userText" />
                      </Header>
                      <Button
                        as={Link}
                        to='/books'
                        size='big'
                        onClick={()=>{window.scrollTo(0,0)}}
                        style={{marginTop: '1em', width: '15em'}}
                        color='green'>
                        <FormattedMessage id="audory.homepage.decide.userButton" />
                      </Button>
                    </Grid.Row>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
          </Container>
        </Segment>
    </Segment>
    <Container text style={{marginTop: '2em', marginBottom: '2em'}}>
    <Header as='h3' style={{ fontSize: '2em' }}>
          <FormattedMessage id="audory.homepage.social.head" />
        </Header>
        <p style={{ fontSize: '1.33em', textAlign: 'justify' }}>
          <FormattedMessage id="audory.homepage.social.body" />
        </p>
        <Grid columns={2} style={{textAlign: 'center'}}>
          <Grid.Row>
            <Grid.Column style={{width: '100%'}}>
                <Button
                color='purple'
                size='big'
                icon
                labelPosition='left'
                href='https://www.instagram.com/audory_official/'
                target='_blank'
                >
                  <Icon name='instagram' />
                  <FormattedMessage id="audory.homepage.social.instagram" />
                </Button>
              </Grid.Column>
              
            
          </Grid.Row>
        </Grid>
        </Container>
        */

const propTypes = {
  intl: intlShape.isRequired,
};

HomePage.propTypes = propTypes;

export default injectIntl(compose(
  withRouter,
)(HomePage));



// WEBPACK FOOTER //
// ./src/components/HomePage.js